import { Card, CardBody, Col, Row } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import {
  Amount,
  Bill,
  Category,
  danger,
  ReimbursementModalBills,
  infoColor,
  light,
  long,
  Members,
  numeric,
  primary,
  Purpose,
  secondary,
  short,
  success,
  View,
  warningColor,
} from "../../../../utils/Constant";
import BadgeDetails from "../../../../CommonElements/Badge/BadgeDetails";
import { dateConversion } from "../../../../utils/dateUtils";
import { openModal } from "../../../../ReduxToolkit/Slice/UserProfileDetailsModalSlice";
import { IReimbursementServiceList, ReimbursementCardProps } from "../../types";

const findUserName = (
  userList: { id: number; name: string }[],
  selectedUser: string
) => {
  const findUserList =
    userList?.length > 0 &&
    userList?.filter((user: { id: number; name: string }) =>
      selectedUser.split(",").includes(user?.id?.toString())
    );
  return findUserList || [];
};

const ReimbursementCards = ({
  findUserBill,
  reimbursementList,
}: ReimbursementCardProps) => {
  const dispatch = useAppDispatch();

  const { data: employeesList } = useAppSelector(
    ({ employeesList }) => employeesList
  );

  const { darkMode } = useAppSelector(({ layout }) => layout);

  return (
    <Row>
      {reimbursementList
        ?.slice()
        .reverse()
        .map((imbursement: IReimbursementServiceList) => {
          const imbursementDate = new Date(imbursement.date).toLocaleDateString(
            "en-US",
            {
              day: numeric,
              month: short,
              weekday: long,
            }
          );
          const userNames = findUserName(
            employeesList?.data ?? [],
            imbursement?.members ?? ""
          );
          return (
            <Col md="6" key={imbursement?.id}>
              <Card className="notification-tabs">
                <CardBody className="">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <BadgeDetails
                      color={light}
                      className={`badget-light f-12 ${
                        darkMode ? "text-white" : "text-dark"
                      }`}
                      text={dateConversion(imbursementDate, true) ?? ""}
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="w-50">
                      <BadgeDetails
                        color={success}
                        badgeHeading={Category}
                        text={imbursement?.destination ?? ""}
                      />
                    </div>
                    <div className="w-50">
                      <BadgeDetails
                        color={infoColor}
                        badgeHeading={Purpose}
                        text={imbursement?.purpose ?? ""}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="w-50">
                      <BadgeDetails
                        color={secondary}
                        badgeHeading={Members}
                        text={
                          userNames?.map(({ name }) => name).join(",") ?? ""
                        }
                      />
                    </div>
                    <div className="w-50">
                      <BadgeDetails
                        color={warningColor}
                        badgeHeading={Amount}
                        text={imbursement?.amount?.toString() ?? ""}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div
                      className="pointer w-50"
                      onClick={() => {
                        findUserBill(Number(imbursement.id));
                        dispatch(
                          openModal({
                            modalType: ReimbursementModalBills,
                          })
                        );
                      }}
                    >
                      <BadgeDetails
                        badgeHeading={Bill}
                        color={primary}
                        text={View}
                      />
                    </div>
                    <div className="w-50">
                      <BadgeDetails
                        color={danger}
                        text={imbursement?.status ?? ""}
                      />
                    </div>
                  </div>
                  <BadgeDetails
                    color={primary}
                    text={imbursement?.description ?? ""}
                  />
                </CardBody>
              </Card>
            </Col>
          );
        })}
    </Row>
  );
};

export default ReimbursementCards;
